// Copyright (c) 2023, Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'
import { Field } from 'redux-form'
import { LabeledInput } from 'components/Form'
import { Lookup } from 'components/index'
import usePathDatabaseSearchRadioLookup from 'components/SearchAndSelect/Sets/common/RadioField/RadioCode/hooks/usePathDatabaseSearchRadioLookup'

const lookupFormName = 'radio-lookup'

const RadioCode = ({ idRoot, sourceForm }) => {
  const {
    assignRadio,
    getLookupTypeProps,
  } = usePathDatabaseSearchRadioLookup(sourceForm, lookupFormName)

  return (
    <>
      <Field
        clearable={() => assignRadio(null)}
        component={LabeledInput}
        id={idRoot}
        label={''}
        name={'radioCode'}
        placeholder={'Radio Code'} />
      <Lookup
        getLookupTypeProps={getLookupTypeProps}
        lookupFormName={lookupFormName}
        lookupLabel={'Radio Lookup'}
        lookupType={'radio'}
        selectRow={assignRadio}
        triggerId={`${idRoot}-lookup-trigger`} />
    </>
  )
}

RadioCode.propTypes = {
  idRoot: string.isRequired,
  sourceForm: string.isRequired,
}

export default RadioCode
